module.exports = __webpack_public_path__ + "media/54.7926ee95.mp3";